import { render } from "./BookingGuestInfo.vue?vue&type=template&id=620beea2&scoped=true"
import script from "./BookingGuestInfo.vue?vue&type=script&lang=js"
export * from "./BookingGuestInfo.vue?vue&type=script&lang=js"

import "./BookingGuestInfo.vue?vue&type=style&index=0&id=620beea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620beea2"]])

export default __exports__